<template>
  <div id="trx-basic-container">
    <f7-list form class="form-group">

        <f7-list-input
            input-id     ="beneficiaryName"
            name         ="beneficiaryName"
            type         ="text"

            v-show       ="showFormInput.root.beneficiaryName"
            :label       ="beneficiaryNameLabel"
            :placeholder ="beneficiaryNameLabel"
            :value       ="beneficiaryName"
            @input       ="setBeneficiaryName($event.target.value); validateInput($event.target); setInput($event.target)"

            maxlength    ="100"
            autocomplete ="off"
            outline
            floating-label
            clear-button
        ></f7-list-input>


        <f7-list-input
          :label       ="$t('beneficiary-country')"
          :placeholder ="$t('beneficiary-country')"
          :value       ="homeCountryName"

          disabled
          outline
          floating-label
        ></f7-list-input>

        <div>
        <f7-list class="form-group">
        <f7-list-input
            id           ="homeNoListId"
            input-id     ="homeNo"
            name         ="homeNo"
            type         ="tel"
            class        ="mobile-input"
            :label       ="$t('beneficiary-home-no-optional')"
            v-show       ="showFormInput.root.homeNo"
            :placeholder  ="$t('beneficiary-home-no-optional')"
            :value       ="homeNo"
            @input       ="setHomeNo($event.target.value); validateInput($event.target); setInput($event.target)"
            autocomplete ="off"
            maxlength    ="15"
            outline
            floating-label
            clear-button
        >
          <f7-link id="txHomeCountryCode" popover-open=".popover-home-no" slot="content-start" class="flag-with-chevron">
            <img :src="getFlagImg(homeIDD)" class="" />
            <span class="">{{ homeIDDCode }}</span>
          </f7-link>
        </f7-list-input>
        </f7-list>

        <f7-popover id="txHomeNoDropdown" class="popover-home-no mobile-country-code transaction" :backdrop="true">
          <f7-searchbar id="txHomeCountryCodeSearch" search-container=".country-code-list" search-in=".country-name" @searchbar:search="onSearch('txHomeCountryCodeSearch')"></f7-searchbar>
          <f7-list class="searchbar-not-found">
              <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
          </f7-list>
          <f7-list class="country-code-list">
            <f7-list-item popover-close link="#" v-for="hIDD in countryCodeList" :key="hIDD.id" @click="changeHomePhoneCode(hIDD.id)">
                <img :src="getFlagImg(hIDD.id)" class="mr-sm"/>
                <span class="country-name">{{hIDD.name+" "+hIDD.idd}}</span>
            </f7-list-item>
          </f7-list>
        </f7-popover>
        </div>

        <div>
        <f7-list class="form-group">
        <f7-list-input
            id           ="mobileNoListId"
            input-id     ="mobileNo"
            name         ="mobileNo"
            type         ="tel"
            class        ="mobile-input"
            :label       ="mobileNoLabel"
            v-show       ="showFormInput.root.mobileNo"
            :placeholder  ="mobileNoLabel"
            :value       ="mobileNo"
            @input       ="setMobileNo($event.target.value); validateInput($event.target); setInput($event.target)"
            autocomplete ="off"
            maxlength    ="15"
            outline
            floating-label
            clear-button
          >
            <f7-link id="txMobileCountryCode" popover-open=".popover-mobile-no" slot="content-start" class="flag-with-chevron">
              <img :src="getFlagImg(mobileIDD)" class="" />
              <span class="">{{ mobileIDDCode }}</span>
            </f7-link>
        </f7-list-input>
        </f7-list>

        <f7-popover id="txMobileNoDropdown" class="popover-mobile-no mobile-country-code transaction" :backdrop="true">
          <f7-searchbar id="txMobileCountryCodeSearch" search-container=".country-code-list" search-in=".country-name" @searchbar:search="onSearch('txMobileCountryCodeSearch')"></f7-searchbar>
          <f7-list class="searchbar-not-found">
              <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
          </f7-list>
          <f7-list class="country-code-list">
            <f7-list-item popover-close link="#" v-for="mIDD in countryCodeList" :key="mIDD.id" @click="changeMobilePhoneCode(mIDD.id)">
                <img :src="getFlagImg(mIDD.id)" class="mr-sm"/>
                <span class="country-name">{{mIDD.name+" "+mIDD.idd}}</span>
            </f7-list-item>
          </f7-list>
        </f7-popover>
        </div>

        <f7-list-input
            input-id     ="email"
            name         ="email"
            type         ="email"

            v-show       ="showFormInput.root.email"
            :label       ="emailLabel"
            :placeholder ="emailLabel"
            :value       ="email"
            @input       ="setEmail($event.target.value); validateInput($event.target); setInput($event.target)"
            autocomplete ="off"
            outline
            floating-label
            clear-button
        ></f7-list-input>


        <f7-list-input
            input-id     ="bankAccountNo"
            name         ="bankAccountNo"
            type         ="text"

            v-show       ="showFormInput.root.bankAccountNo"
            :label       ="bankAccountNoLabel"
            :placeholder ="bankAccountNoLabel"
            :value       ="bankAccountNo"
            @input       ="setBankAccountNo($event.target.value); validateInput($event.target); setInput($event.target)"

            maxlength    ="30"
            autocomplete ="off"
            outline
            floating-label
            clear-button
        ></f7-list-input>

        <f7-list-input
          id            ="walletNo"
          input-id      ="walletNo"
          name          ="walletNo"
          type          ="tel"
          class         ="mobile-input"
          :label        ="$t('beneficiary-mobile-topup-no')"
          :placeholder  ="$t('beneficiary-mobile-topup-no')"
          :value        ="walletNo"
          @input        ="setWalletNo($event.target.value); validateInput($event.target); setInput($event.target)"
          v-show        ="showFormInput.root.walletNo"
          maxlength    ="30"
          autocomplete ="off"
          outline
          floating-label
          clear-button
        >
          <f7-link popover-open=".popover-mobile-no" slot="content-start" style="pointer-events: none; cursor: default" class="" readonly>
            <img :src="getFlagImg(homeCountryId)" class="" />
            <span class="">{{ homeCountryIdd }}</span>
          </f7-link>
        </f7-list-input>

    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {

    },
    mounted() {
      console.log("BANK ACCOUNT LABEL",this.bankAccountNoLabel);
      console.log("MODIFY TX : ", this.showFormInput)
      this.init();
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('transaction', [
          'showFormSet',
          'showFormInput',
          'bankAccountNo',
          'bankAccountNoLabel',
          'beneficiaryNameLabel',
          'beneficiaryName',
          'beneficiaryFullName',
          'homeNo',
          'homeIDD',
          'homeCountryName',
          'homeIDDCode',

          'countryCodeList',
          'mobileNoLabel',
          'mobileNo',
          'mobileIDD',
          'mobileIDDCode',
          'emailLabel',
          'email',
          'walletNo',
          'mobileIDDCode',
          'mobileIDD',
          'homeCountryId',
          'homeCountryIdd',
      ]),
      ...mapGetters('misc', [
        'latestCountryCodePopoverDirection',
      ])
    },
    methods: {
      ...mapActions('transaction', [
          'setBankAccountNo',
          'setBeneficiaryName',
          'setHomeNo',
          'setMobileNo',
          'setEmail',
          'setWalletNo'
      ]),

      init(){
        const self    = this;

        const popover = ".transaction.popover-home-no";
        const popoverInner = ".transaction.popover-home-no .popover-inner";
        const popoverId = "txHomeNoDropdown";
        const inputId = "homeNo";
        const inputListId = "#homeNoListId";

        self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "txHomeCountryCode", "txHomeCountryCodeSearch")

        const popover2 = ".transaction.popover-mobile-no";
        const popoverInner2 = ".transaction.popover-mobile-no .popover-inner";
        const popoverId2 = "txMobileNoDropdown";
        const inputId2 = "mobileNo";
        const inputListId2 = "#mobileNoListId";

        self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2, "mobile-input", "txMobileCountryCode", "txMobileCountryCodeSearch")
      },

      changeHomePhoneCode(id){
        this.$emit("changeHomePhoneCode", id);
      },

      changeMobilePhoneCode(id){
        this.$emit("changeMobilePhoneCode", id);
      },

      validateInput(inputEl){
        this.$emit("validateInput", inputEl);
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      },

      onSearch(searchbarId){
        const self    = this;
        if(self.latestCountryCodePopoverDirection == "above"){
            if(searchbarId == "txHomeCountryCodeSearch"){
                const popover = ".transaction.popover-home-no";
                const popoverInner = ".transaction.popover-home-no .popover-inner";
                const popoverId = "txHomeNoDropdown";
                const inputId = "homeNo";
                const inputListId = "#homeNoListId";

                self.setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "txHomeCountryCode", "txHomeCountryCodeSearch", true)

            }else if(searchbarId == "txMobileCountryCodeSearch"){
                const popover2 = ".transaction.popover-mobile-no";
                const popoverInner2 = ".transaction.popover-mobile-no .popover-inner";
                const popoverId2 = "txMobileNoDropdown";
                const inputId2 = "mobileNo";
                const inputListId2 = "#mobileNoListId";

                self.setPopoverPosition(popover2, popoverInner2, popoverId2, inputId2, inputListId2, "mobile-input", "txMobileCountryCode", "txMobileCountryCodeSearch", true)
            }
            
        }
      }
    }
  }
</script>